import { Component, Input, OnInit } from '@angular/core';
import { EstructuraNiveles } from 'src/app/model/ReglamentoInterno.model';

@Component({
  selector: 'app-niveles-reglamento',
  templateUrl: './niveles-reglamento.component.html',
  styleUrls: ['./niveles-reglamento.component.css']
})
export class NivelesReglamentoComponent implements OnInit {

  @Input() estructuraNiveles : EstructuraNiveles;
  @Input() readonly : boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
